import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { SesionService } from './sesion.service';


@Injectable()
export class BannerService extends ApiService {
  constructor(sesion: SesionService) {
      super('banner')
      sesion.registrarURLSinIndicadorCarga(this.url(''));
  }

  banner(): Observable<string> {
    return this.http.get<string>(this.url(''));
  }

  
}

